import { IconName } from '@tallo/design-system';

export type IncludedUtilities = 'water' | 'sewage' | 'garbage' | 'electricity' | 'gas' | 'internet' | 'cable';

type UtilitiesItems = {
  [key in IncludedUtilities]: boolean | null;
};

export interface IncludedUtilitiesDto extends UtilitiesItems {
  id: string;
  isUtilitiesIncludedInRent: boolean | null;
}

export const includedUtilitiesMap = new Map<IncludedUtilities, string>([
  ['water', 'Water'],
  ['sewage', 'Sewage'],
  ['garbage', 'Garbage'],
  ['electricity', 'Electricity'],
  ['gas', 'Gas'],
  ['internet', 'Internet'],
  ['cable', 'Cable'],
]);

export const includedUtilityIconsMap: { [key in IncludedUtilities]: IconName } = {
  water: 'droplet',
  sewage: 'pipe',
  garbage: 'trash',
  electricity: 'zap',
  gas: 'flame',
  internet: 'wifi',
  cable: 'tv-01',
};
